import { Flex } from "@engaging-tech/components"
import styled from "styled-components"

/* eslint-disable import/prefer-default-export */
export const RoundedBorderFlex = styled(Flex)`
  border-radius: 5px 5px 0px 0px;
`
